import { useMemo } from 'react';
import { useFilterChangeCallback, useDebouncedCallback } from 'shared/hooks';
import { FILTER_KEY } from '../constants';

export const useSuburbanAreaChangeHandler = () => {
  const onChange = useFilterChangeCallback(FILTER_KEY);

  const onHouseAreaMinChange = useDebouncedCallback((gte: number | null) => {
    onChange({ action: 'setAreaMin', arguments: [gte] });
  }, 300);

  const onHouseAreaMaxChange = useDebouncedCallback((lte: number | null) => {
    onChange({ action: 'setAreaMax', arguments: [lte] });
  }, 300);

  const onLandAreaMinChange = useDebouncedCallback((gte: number | null) => {
    onChange({ action: 'setLandAreaMin', arguments: [gte] });
  }, 300);

  const onLandAreaMaxChange = useDebouncedCallback((lte: number | null) => {
    onChange({ action: 'setLandAreaMax', arguments: [lte] });
  }, 300);

  return useMemo(
    () => ({
      onHouseAreaMinChange,
      onHouseAreaMaxChange,
      onLandAreaMinChange,
      onLandAreaMaxChange,
    }),
    [onHouseAreaMaxChange, onHouseAreaMinChange, onLandAreaMaxChange, onLandAreaMinChange],
  );
};
